module.exports = __webpack_public_path__ + "static/media/mail_verified.82cc596f.svg";